import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../core/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
    isLoading: Observable<boolean>;

  constructor(private loaderService: LoaderService) {
     this.isLoading = this.loaderService.isLoading;
      this.loaderService.isLoading.subscribe(val => {
    console.log('[LoaderComponent] isLoading:', val);
  });
  }

  ngOnInit() {
    console.log("loader component called")
  }
}
